import React, { useMemo, useState } from "react";

function formatCurrency(n) {
  if (n == null || isNaN(n)) return "-";
  return Number(n).toLocaleString();
}

const StatCard = ({ title, value }) => (
  <div className="bg-white/10 rounded-md p-3 flex-1 min-w-[160px]">
    <div className="text-xs text-white/80">{title}</div>
    <div className="mt-2 text-lg font-semibold text-white">{value}</div>
  </div>
);

export default function ViewCooperative() {
  const [cooperatives] = useState(() => {
    // 10 mock cooperative entries
    return [
      { id: 1, name: "Bahir Coffee Coop", city: "Bahir Dar", woreda: "01", manager_phone: "+251911000001", capital: 150000, created_at: "2023-05-10" },
      { id: 2, name: "Sheger Dairy Coop", city: "Addis Ababa", woreda: "09", manager_phone: "+251911000002", capital: 250000, created_at: "2024-01-12" },
      { id: 3, name: "Amhara Teff Coop", city: "Bahir Dar", woreda: "03", manager_phone: "+251911000003", capital: 125000, created_at: "2022-11-02" },
      { id: 4, name: "Sidama Exporters", city: "Hawassa", woreda: "05", manager_phone: "+251911000004", capital: 400000, created_at: "2024-02-01" },
      { id: 5, name: "Oromia Grain Coop", city: "Jimma", woreda: "02", manager_phone: "+251911000005", capital: 90000, created_at: "2021-07-21" },
      { id: 6, name: "Harar Honey Coop", city: "Harar", woreda: "04", manager_phone: "+251911000006", capital: 60000, created_at: "2023-09-15" },
      { id: 7, name: "Gedeo Coffee Growers", city: "Dilla", woreda: "07", manager_phone: "+251911000007", capital: 310000, created_at: "2024-02-10" },
      { id: 8, name: "Tigray Textile Coop", city: "Mekelle", woreda: "06", manager_phone: "+251911000008", capital: 45000, created_at: "2020-12-03" },
      { id: 9, name: "Afar Fishers Coop", city: "Semera", woreda: "08", manager_phone: "+251911000009", capital: 230000, created_at: "2023-03-30" },
      { id: 10, name: "SNNP Women Coop", city: "Wolaita", woreda: "10", manager_phone: "+251911000010", capital: 175000, created_at: "2022-02-14" },
    ];
  });

  const isSheger = (c) => {
    const city = (c.city || "").toString().toLowerCase();
    const name = (c.name || "").toString().toLowerCase();
    return city.includes("sheger") || name.includes("sheger") || city === "addis ababa";
  };

  const filtered = cooperatives.filter(isSheger);

  const capitals = filtered.map((c) => Number(c.capital ?? 0)).filter((n) => !isNaN(n));
  const topCapital = capitals.length ? formatCurrency(Math.max(...capitals)) : "-";
  const minCapital = capitals.length ? formatCurrency(Math.min(...capitals)) : "-";
  const totalCapital = capitals.length ? formatCurrency(capitals.reduce((s, n) => s + n, 0)) : "-";
  const avgCapital = capitals.length ? formatCurrency(Math.round(capitals.reduce((s, n) => s + n, 0) / capitals.length)) : "-";

  const newest = filtered.slice().sort((a, b) => {
    const ta = a.created_at ? Date.parse(a.created_at) : 0;
    const tb = b.created_at ? Date.parse(b.created_at) : 0;
    return tb - ta;
  })[0];

  const oldest = filtered.slice().sort((a, b) => {
    const ta = a.created_at ? Date.parse(a.created_at) : 0;
    const tb = b.created_at ? Date.parse(b.created_at) : 0;
    return ta - tb;
  })[0];

  const count = filtered.length;

  return (
    <div>
      <div className="mb-6 flex gap-4 flex-wrap">
        <StatCard title="Count" value={count} />
        <StatCard title="Top capital" value={topCapital} />
        <StatCard title="Minimum capital" value={minCapital} />
        <StatCard title="Total capital" value={totalCapital} />
        <StatCard title="Average capital" value={avgCapital} />
        <StatCard title="Newest" value={newest ? `${newest.name}` : "-"} />
        <StatCard title="Oldest" value={oldest ? `${oldest.name}` : "-"} />
      </div>

      <div className="rounded-lg bg-white/5 p-4">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-white">Cooperative Societies (Sheger City)</h3>
          <div className="text-sm text-white/80">{`${filtered.length} items`}</div>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 text-left text-blue-400 bg-white">
            <thead>
              <tr className="text-sm text-blue-400">
                <th className="py-2 px-3">Name</th>
                <th className="py-2 px-3">City</th>
                <th className="py-2 px-3">Woreda</th>
                <th className="py-2 px-3">Manager Phone</th>
                <th className="py-2 px-3">Capital</th>
                <th className="py-2 px-3">Created At</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filtered.map((c) => (
                <tr key={c.id} className="hover:bg-gray-50">
                  <td className="py-2 px-3">{c.name}</td>
                  <td className="py-2 px-3">{c.city || '-'}</td>
                  <td className="py-2 px-3">{c.woreda || '-'}</td>
                  <td className="py-2 px-3">{c.manager_phone || '-'}</td>
                  <td className="py-2 px-3">{formatCurrency(c.capital)}</td>
                  <td className="py-2 px-3">{c.created_at || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
